










import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { ProjectModel } from "../models";

import SubscriptionsTable from "../components/SubscriptionsTable.vue";
import { SnackbarInterface } from "shared/store/snackbar/state";

const pStore = namespace("projects");
const snackStore = namespace("snackbar");

@Component({
  components: { SubscriptionsTable },
})
export default class MySubscriptions extends Vue {
  @pStore.Getter allSubscriptions!: ProjectModel;

  @pStore.Action fetchSubscriptions!: () => Promise<void>;

  @snackStore.Mutation setSnackbar!: (payload: SnackbarInterface) => void;

  mounted(): void {
    this.fetchSubscriptions().catch((): void => {
      this.setSnackbar({
        text: this.$t("global.errors.default").toString(),
        color: "error",
      });
    });
  }
}
